module.exports = "/_next/static/images/DeepenYourUnderstanding@2x-342eb04600ef26275a15f9e071b7efa7.webp";